if (!customElements.get('image-collage-slider')) {
  customElements.define(
    'image-collage-slider',
    class ImageCollageSlider extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.rows = this.querySelectorAll('.image-collage__row.swiper');
        this.autoplayEnabled = this.dataset.autoplay ? true : false;
        this.autoplaySpeed = this.dataset.autoplay ? parseInt(this.dataset.autoplay) : 6000;
        this.sliderInstances = [];

        this.initSliders();

        if (this.autoplayEnabled) {
          FoxTheme.Motion.inView(this, this.playInView.bind(this));
        }
      }

      playInView() {
        this.play();

        return () => {
          this.pause();
        };
      }

      play() {
        this.sliderInstances.forEach((instance) => {
          if (instance.slider && instance.slider.autoplay) {
            instance.slider.autoplay.start();
          }
        });
      }

      pause() {
        this.sliderInstances.forEach((instance) => {
          if (instance.slider && instance.slider.autoplay) {
            instance.slider.autoplay.stop();
          }
        });
      }

      disconnectedCallback() {
        this.sliderInstances.forEach((instance) => {
          if (instance.slider) {
            instance.slider.destroy();
          }
        });
      }

      initSliders() {
        const spaceBetween = parseInt(getComputedStyle(this).getPropertyValue('--column-gap')) || 24;

        Array.from(this.rows).forEach((row, index) => {
          const sliderOptions = {
            slidesPerView: 'auto',
            spaceBetween: spaceBetween,
            loop: true,
            speed: this.autoplaySpeed,
            grabCursor: !this.autoplayEnabled,
            allowTouchMove: !this.autoplayEnabled,
            threshold: 2,
          };

          // Add continuous marquee autoplay if enabled
          if (this.autoplayEnabled) {
            sliderOptions.autoplay = {
              delay: 1,
              disableOnInteraction: false,
              reverseDirection: index % 2 !== 0, // Alternate direction for second row
            };
          }

          const sliderInstance = new window.FoxTheme.Carousel(row, sliderOptions, [
            FoxTheme.Swiper.Autoplay,
          ]);
          sliderInstance.init();

          this.sliderInstances.push(sliderInstance);
        });
      }
    }
  );
}
